module.exports = __webpack_public_path__ + "static/media/Malgun Gothic.db2c26fc.woff";